module.exports = __webpack_public_path__ + "fonts/roboto-v27-latin-ext_latin-regular.15f198b.ttf";